import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 7.062V8a1 1 0 1 1-2 0v-.938A7.96 7.96 0 0 0 7.094 8.68l.664.663a1 1 0 1 1-1.415 1.414l-.663-.663A7.96 7.96 0 0 0 4.062 14H5a1 1 0 1 1 0 2h-.938c.07.566.2 1.114.382 1.636a1 1 0 0 1-1.888.659A10 10 0 0 1 2 15C2 9.477 6.477 5 12 5c.962 0 1.894.136 2.777.391a1 1 0 0 1-.554 1.922A8 8 0 0 0 13 7.062m5.32 3.032-4.388 4.388Q14 14.73 14 15a2 2 0 1 1-1.482-1.932l6.775-6.775a1 1 0 1 1 1.414 1.414l-.964.964A9.96 9.96 0 0 1 22 15a10 10 0 0 1-.556 3.295 1 1 0 0 1-1.888-.659c.182-.522.312-1.07.382-1.636H19a1 1 0 1 1 0-2h.938a7.96 7.96 0 0 0-1.618-3.906",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_mileage-sBAKMKeP.js.map
